import React from "react";
import { IListItem, Dropdown } from "../../Common/UI/Index";

export interface IYearViewProps{

  /**
   * Selected year in the dropdown
   */
  selectedYear: string;

  /**
   * Years list for the dropdown
   */
  yearsList: IListItem[];

  /**
   * Callback function for on change of financial year dropdown
   */
  onYearChange: (selected: string) => void;
}

/**
 * Responsible render financial year dropdown
 */
export const FinancialYearView: React.FC<IYearViewProps> =
(props: IYearViewProps): JSX.Element => {
  const { selectedYear, yearsList, onYearChange } = props;

  return (
    <Dropdown
      data-testid="financial-year-dropdown"
      name="FinancialYears"
      dataSource={yearsList}
      onChange={onYearChange}
      value={selectedYear} />
  );
};
